"use strict";
var arrayMap = require('./_arrayMap'), baseGet = require('./_baseGet'), baseIteratee = require('./_baseIteratee'), baseMap = require('./_baseMap'), baseSortBy = require('./_baseSortBy'), baseUnary = require('./_baseUnary'), compareMultiple = require('./_compareMultiple'), identity = require('./identity'), isArray = require('./isArray');
function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) {
        iteratees = arrayMap(iteratees, function (iteratee) {
            if (isArray(iteratee)) {
                return function (value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
            }
            return iteratee;
        });
    }
    else {
        iteratees = [identity];
    }
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function (value, key, collection) {
        var criteria = arrayMap(iteratees, function (iteratee) {
            return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
    });
    return baseSortBy(result, function (object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;
//# sourceMappingURL=_baseOrderBy.js.map